<template>
  <div class="content">
    <div class="top">
      <div class="elec_speed">
        <el-steps :active="2" finish-status="success" simple>
          <el-step :title=selectedSeries></el-step>
          <el-step :title=loadCondition></el-step>
          <el-step :title=reducerSize></el-step>
          <el-step :title=selectMotor></el-step>
          <el-step :title=complete></el-step>
        </el-steps>
      </div>
    </div>
    <div class="elec_select">
      <el-row>
        <el-col :span="12">
          <div class="grid-content bg-purple elec_select_left">
            <img :src=picUrl alt="">
            <div class="text">
              <!-- <h4>电机厂商 <span>ABB</span></h4>
              <h4>电机型号 <span>8C1.60.10</span></h4> -->
              <h4>{{$t('message.Reducersystem')}} <span>{{ reducer_series_name }}</span></h4>
            </div>
          </div>
        </el-col>

        <!-- 多级选择菜单 -->
        <el-col :span="12">
          <div class="grid-content bg-purple-light elec_select_right">
            <div class="select_box">
              <h3>{{$t('message.selectSizeInfo')}} <span style="color:red;font-size:12px;">{{$t('message.info12')}}</span></h3>
              <div class="radio_box">
                <el-cascader
                  :options="options"
                  v-model="selectedOptions"
                  :props="optionProps"
                  :show-all-levels="false"
                  @change="handleChange">
                </el-cascader>
              </div>
              <span class="renturnPrePage" @click="renturnPrePage">{{$t('message.Return')}}</span>
              <span class="toNextPage" @click="toNextPage">{{$t('message.Next')}}</span>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
    <!-- 下载规格书·外形图 & 资料页-->
    <div class="elec_detail">
      <el-row>
        <!-- <el-col :span="24">
          <h2>下载规格书·外形图</h2>
        </el-col>
        <el-col :span="24" style="padding-top:30px;font-weight:bold;">
          <el-col :span="8">产品规格表</el-col>
          <el-col :span="8">外形图</el-col>
          <el-col :span="8">CAD数据(2D-3D)</el-col>
        </el-col>
        <el-col :span="24" style="padding-top:30px;">
          <el-col :span="8">
            <div class="downloadSpec">
              <h4>VRS-060C-5-K3-14BE9（附带输出键）</h4>
              <el-button class="button_first" size="mini">PDF下载</el-button>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="downloadSpec">
              <h4>VRS-060C-5-K3-14BE9（附带输出键）</h4>
              <el-button class="button_first" size="mini">PDF下载</el-button>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="downloadSpec">
              <h4>VRS-060C-5-K3-14BE9（附带输出键）</h4>
              <el-button class="button_first" size="mini">PDF下载</el-button>
              <el-button size="mini">IGS下载</el-button>
              <el-button size="mini">STP下载</el-button>
            </div>
          </el-col>
        </el-col>
        <el-col :span="24" style="padding-top:30px;">
          <el-col :span="8">
            <div class="downloadSpec">
              <h4>VRS-060C-5-K3-14BE9（不附带输出键）</h4>
              <el-button class="button_first" size="mini">PDF下载</el-button>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="downloadSpec">
              <h4>VRS-060C-5-K3-14BE9（不附带输出键）</h4>
              <el-button class="button_first" size="mini">PDF下载</el-button>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="downloadSpec">
              <h4>VRS-060C-5-K3-14BE9（不附带输出键）</h4>
              <el-button class="button_first" size="mini">PDF下载</el-button>
              <el-button size="mini">IGS下载</el-button>
              <el-button size="mini">STP下载</el-button>
            </div>
          </el-col>
        </el-col> -->
        <el-col :span="24" style="padding-top:20px;">
          <h2>{{$t('message.Information')}}</h2>
          <el-collapse v-model="activeNames" style="background:#FCFCFC;">
            <el-collapse-item :title=DecelerationDimensionDetails name="1">
              <el-row class="card_box">
                <el-table :data="tableData" border style="width: 100%" :header-cell-style="{background:'#F4F4F4'}">
                  <el-table-column
                    prop="reducer_size"
                    :label=GearboxModel
                    align="center">
                  </el-table-column>
                  <el-table-column
                    prop="L"
                    :label=Life
                    align="center">
                  </el-table-column>
                  <el-table-column
                    prop="isAble"
                    :label=Judge
                    align="center">
                  </el-table-column>
                  <el-table-column
                    prop="content"
                    :label=Note
                    align="center">
                  </el-table-column>
                </el-table>
              </el-row>
              <!-- <el-row class="card_box" style="margin-top:30px;">
                <div class="card_box_column_top">
                  <el-col :span="12">备注栏的说明</el-col>
                  <el-col :span="12">对应策略</el-col>
                </div>
                <div class="card_box_column">
                  <el-col :span="12" class="item">有可能超过容许平均输出扭矩</el-col>
                  <el-col :span="12" class="item">段位选择偏大1号时，输出扭矩请控制在容许平均输出扭矩范围内 </el-col>
                </div>
                <div class="card_box_column">
                  <el-col :span="12" class="item">有可能超过容许平均输出扭矩</el-col>
                  <el-col :span="12" class="item">段位选择偏大1号时，输出扭矩请控制在容许平均输出扭矩范围内 </el-col>
                </div>
                <div class="card_box_column">
                  <el-col :span="12" class="item">有可能超过容许平均输出扭矩</el-col>
                  <el-col :span="12" class="item">段位选择偏大1号时，输出扭矩请控制在容许平均输出扭矩范围内 </el-col>
                </div>
                <div class="card_box_column">
                  <el-col :span="12" class="item">有可能超过容许平均输出扭矩</el-col>
                  <el-col :span="12" class="item">段位选择偏大1号时，输出扭矩请控制在容许平均输出扭矩范围内 </el-col>
                </div>
              </el-row> -->
            </el-collapse-item>
          </el-collapse>
        </el-col>
      </el-row>
    </div>
  </div>
</template>
<script>
  import {
    getPicUrl
  } from '@/store/electric_motor'
  export default {
    name: 'SelectedSize',
    data() {
      return {
        options: [],
        selectedOptions: [],
        optionProps: {
          value: 'value',
          label: 'label',
        },
        tabPosition: 'left',
        size_radio:'1',
        activeNames: ['1'],
        tableData: [],
        machineSize: '',
        reducer_series_name:'',
        reducer_ratio:'',
        selectedSeries: this.$t('message.selectedSeries'),
        loadCondition: this.$t('message.loadCondition'),
        reducerSize: this.$t('message.reducerSize'),
        selectMotor: this.$t('message.selectMotor'),
        complete: this.$t('message.complete'),
        DecelerationDimensionDetails: this.$t('message.DecelerationDimensionDetails'),
        GearboxModel: this.$t('message.GearboxModel'),
        Judge: this.$t('message.Judge'),
        Life: this.$t('message.Life'),
        Note: this.$t('message.Note'),
        param_complete_list:{},
        picUrl:''
      };
    },
    props: {
      param_1:Object,
      required:true,
      param_2:Object,
      required:true
    },
    beforeUpdate(){
      getPicUrl(this.param_1.reducer_series_name).then((response) => {
        if (response.success === true) {
          this.picUrl = response.data[0].outlook_picture
        }
      })
    },
    methods: {
      renturnPrePage:function(){
        this.$emit("listenPageChange","to_LoadPage");
      },
      toNextPage:function(){
        console.log(this.reducer_ratio);
        if(this.reducer_ratio !== ''){
        //if(JSON.stringify(this.reducer_ratio) === '{}'){
          this.$emit("listenPageChange","to_MotorPage")
          this.$emit("listenParam_3",this.reducer_ratio)
          this.$emit("listenParam_list",this.param_complete_list)
        }else{
          this.$message({
            message: '请选择减速机型号!',
            type: 'warning'
          })
        }
      },
      // 通过前面参数获取可用的减速机型号
      _getListReducerisAble:function(){

        // 为解一个bug
        var sign = sessionStorage.getItem('sign_num2');
        if(sign !== 'motor'){
          this.options = [];
        }
        sessionStorage.removeItem('sign_num2');
        // over

        this.reducer_series_name = this.param_1.reducer_series_name;
        const array = this.param_2.array;
        // 获取合适的减速机型号
        for(var i=0;i < array.length;i++){
          if(array[i].isAble === '1'){
            this.options.push({
              'label':array[i].reducer_size,
              'value':array[i].reducer_size
            });
          }
        }
        if(this.options.length === 0){
          this.$message({
            message: '没有合适的减速机型号供选择!',
            type: 'warning'
          });
        }

        var lang = localStorage.getItem('lang');
            if(lang == 'cn'){
              for(var i=0 ; i < array.length ; i++){
                if(array[i].isAble === "0" || array[i].isAble === 0){
                  array[i].isAble = '不可用'
                }else if(array[i].isAble === "1"){
                  array[i].isAble = '可用'
                }
              }
            }else if(lang == 'en'){
              for(var i=0 ; i < array.length ; i++){
                if(array[i].isAble === "0" || array[i].isAble === 0){
                  array[i].isAble = 'NG'
                }else if(array[i].isAble === "1"){
                  array[i].isAble = 'OK'
                }
              }
            }
        // 获取减速机使用详情表格数据

        this.tableData = array;
      },
      handleChange(val){
        this.reducer_ratio = val[0];

        var tableDataArray = this.tableData;
        for(var i=0;i<tableDataArray.length;i++){
          if(tableDataArray[i].reducer_size === val[0]){
            //数据存入缓存
            sessionStorage.setItem('isAble', tableDataArray[i].isAble);
            sessionStorage.setItem('n2max', tableDataArray[i].n2max);
            sessionStorage.setItem('mass', tableDataArray[i].mass);
            sessionStorage.setItem('F2rm', tableDataArray[i].F2rm);
            sessionStorage.setItem('n2m', tableDataArray[i].n2m);
            sessionStorage.setItem('max_speed', tableDataArray[i].max_speed);
            sessionStorage.setItem('moment_of_inertia', tableDataArray[i].moment_of_inertia);
            sessionStorage.setItem('L', tableDataArray[i].L);
            sessionStorage.setItem('full_load_efficiency', tableDataArray[i].full_load_efficiency);
            sessionStorage.setItem('T2m', tableDataArray[i].T2m);
            sessionStorage.setItem('F2amax', tableDataArray[i].F2amax);
            sessionStorage.setItem('F2rmax', tableDataArray[i].F2rmax);
            sessionStorage.setItem('F2am', tableDataArray[i].F2am);
            sessionStorage.setItem('rated_output_torque', tableDataArray[i].rated_output_torque);
            sessionStorage.setItem('max_axial_force', tableDataArray[i].max_axial_force);
            sessionStorage.setItem('rm', tableDataArray[i].rm);
            sessionStorage.setItem('reducer_size', tableDataArray[i].reducer_size);
            sessionStorage.setItem('KPL', tableDataArray[i].KPL);
            sessionStorage.setItem('max_radial_force', tableDataArray[i].max_radial_force);
            sessionStorage.setItem('T2max', tableDataArray[i].T2max);
          }
        }
      }
    }
  };
</script>
<style scoped>
  .content {
    width:100%;
    height: 100%;
    background: white;
    border-radius: 5px;
    box-shadow: 0 0 15px rgb(224, 224, 224);
  }
  .top {
    height:100px;
    border-bottom:1px solid #EBEBEB;
  }
  .elec_speed {
    width:80%;
    margin:0 auto;
    padding-top:25px;
  }
  .el-steps {
    border-radius: 10px;
    background-color: #F5F7FA;
    background:url('../../../static/step.png') no-repeat #F5F7FA;
    background-size:20% 100%;
    background-position-x:53%;
  }
  .elec_select_left img{
    width: 35%;
    height: 35%;
    display: block;
    margin: 0 auto;
    padding-top: 70px;
  }
  .elec_select_left .text{
    text-align: left;
    font-weight: bold;
    margin-left: 280px;
  }
  .elec_select_left .text h4 {
    padding-top:5px;
  }
  .elec_select_left .text h4 span{
    padding-left:30px;
  }
  .el-cascader-menus el-popper{
    z-index: 2010;
    position: absolute;
    top: 284px;
    left: 952px;
  }
  .select_box {
    padding-left:10px;
    padding-top:80px;
  }
  .toNextPage {
    width:97px;
    height:42px;
    border-radius: 5px;
    background: #142479;
    text-align: center;
    line-height: 42px;
    color:white;
    margin-top:40px;
    display: inline-block;
    margin-left:15px;
    cursor: pointer;
  }
  .renturnPrePage {
    width:97px;
    height:42px;
    border-radius: 5px;
    background: #142479;
    text-align: center;
    line-height: 42px;
    color:white;
    margin-top:40px;
    display: inline-block;
    cursor: pointer;
  }
  .elec_detail {
    width:80%;
    margin:0 auto;
    margin-top:70px;
  }
  .detail_img {
    width:150px;
    height:150px;
  }
  .detail_img_box {
    width:70%;
    margin:0 auto;
    padding-top:20px;
  }
  .radio_box {
    margin-top:50px;
  }
  .radio_box .el-radio {
    width:140px;
    height:70px;
    height:70px;
  }
  .downloadSpec {
    width:350px;
    height:115px;
    background-color: #F4F4F4;
    border-radius: 10px;
  }
  .downloadSpec h4 {
    text-align: center;
    padding-top:30px;
    font-weight: normal;
  }
  .downloadSpec .el-button {
    margin-top:15px;
  }
  .downloadSpec .button_first {
    margin-left:30px;
  }

  .card_box {
    margin-top:20px;
    width:90%;
    margin:0 auto;
    height:100%;
  }
  .card_box_column {
    border-bottom:1px solid #ccc;
    padding-top:20px;
    height:100px;
    text-align: center;
  }
  .card_box_column .item {
    line-height: 70px;
  }
  .card_box_column .item_2 {
    width:250px;
    margin-left:50px;
  }
  .card_box_column_top {
    border-bottom:1px solid #ccc;
    height:70px;
    line-height: 70px;
    text-align: center;
  }
  /* 1366px下样式 */
  @media screen and (max-width: 1367px) {
    .card_box_column .item_2 {
      width:180px;
      margin-left:30px;
    }
    .card_box_column .item {
      line-height: 30px;
      padding-top:30px;
    }
    .elec_select_left .text{
      text-align: left;
      font-weight: bold;
      margin-left: 180px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/view/LoadSelection/SelectedSize.vue